import { REGIONS_MUNICIPALITIES_FEATURES } from '@schema/featureToggle'

export const regionsTabsQueryParamName = 'tab'

export const regionsTabs = REGIONS_MUNICIPALITIES_FEATURES
